import React from 'react';
import { Database, Plus } from 'lucide-react';
import { Button } from '../../../components/ui/Button';

export const TableEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-96 text-center p-4">
      <Database size={36} className="text-cf-textMuted mb-3" />
      <h3 className="text-sm font-semibold text-cf-textPrimary">No Datastores Found</h3>
      <p className="text-xs text-cf-textSecondary mt-1 max-w-sm">
        This project does not contain any datastores yet. Create your first table to start ingesting form submissions.
      </p>
      <Button
        variant="primary"
        size="sm"
        className="mt-4"
        leftIcon={<Plus size={14} />}
        onClick={() => window.dispatchEvent(new CustomEvent('ericius:open-create-table'))}
      >
        Create Datastore
      </Button>
    </div>
  );
};
